
// Utility functions for transforming data between different formats

export interface LocationState {
  id: string;
  name: string;
  abbreviation: string;
}

export interface LocationCity {
  id: string;
  name: string;
}

export interface SelectOption {
  value: string;
  label: string;
}

export const transformStatesToOptions = (states: LocationState[]): SelectOption[] => {
  return states.map(state => ({
    value: state.abbreviation,
    label: state.name
  }));
};

export const transformCitiesToOptions = (cities: LocationCity[]): SelectOption[] => {
  return cities.map(city => ({
    value: city.id,
    label: city.name
  }));
};

// Transform SelectOptions back to LocationState format for components that expect it
export const transformOptionsToStates = (options: SelectOption[]): LocationState[] => {
  return options.map(option => ({
    id: option.value,
    name: option.label,
    abbreviation: option.value
  }));
};

// Transform SelectOptions back to LocationCity format for components that expect it
export const transformOptionsToCities = (options: SelectOption[]): LocationCity[] => {
  return options.map(option => ({
    id: option.value,
    name: option.label
  }));
};

// Helper function to derive state abbreviation from full name if needed
export const deriveStateAbbreviation = (stateName: string): string => {
  const stateAbbreviations: Record<string, string> = {
    'Alabama': 'AL', 'Alaska': 'AK', 'Arizona': 'AZ', 'Arkansas': 'AR', 'California': 'CA',
    'Colorado': 'CO', 'Connecticut': 'CT', 'Delaware': 'DE', 'Florida': 'FL', 'Georgia': 'GA',
    'Hawaii': 'HI', 'Idaho': 'ID', 'Illinois': 'IL', 'Indiana': 'IN', 'Iowa': 'IA',
    'Kansas': 'KS', 'Kentucky': 'KY', 'Louisiana': 'LA', 'Maine': 'ME', 'Maryland': 'MD',
    'Massachusetts': 'MA', 'Michigan': 'MI', 'Minnesota': 'MN', 'Mississippi': 'MS', 'Missouri': 'MO',
    'Montana': 'MT', 'Nebraska': 'NE', 'Nevada': 'NV', 'New Hampshire': 'NH', 'New Jersey': 'NJ',
    'New Mexico': 'NM', 'New York': 'NY', 'North Carolina': 'NC', 'North Dakota': 'ND', 'Ohio': 'OH',
    'Oklahoma': 'OK', 'Oregon': 'OR', 'Pennsylvania': 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC',
    'South Dakota': 'SD', 'Tennessee': 'TN', 'Texas': 'TX', 'Utah': 'UT', 'Vermont': 'VT',
    'Virginia': 'VA', 'Washington': 'WA', 'West Virginia': 'WV', 'Wisconsin': 'WI', 'Wyoming': 'WY'
  };
  
  return stateAbbreviations[stateName] || stateName;
};
